import React, { FC } from 'react';

export const RemoveIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ height: '1em', width: '1em' }}
    className={className}
  >
    <path d="M19 13H5v-2h14v2z" />
  </svg>
);
